import React from 'react';

// Renders tenant footer copy without dangerouslySetInnerHTML. Each line is an
// array of segments; a segment with `block: true` becomes block-level on mobile
// (via .block-on-mobile) to control where the line wraps on small screens.
// Registered trademark symbols (®) are automatically superscripted.
const superscriptTrademark = (text) => {
  const parts = text.split('®');
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 && <sup style={{ verticalAlign: 'super', fontSize: '0.6em' }}>®</sup>}
    </React.Fragment>
  ));
};

const FooterLines = ({ lines, lineStyle }) =>
  lines.map((segments, i) => (
    <p key={i} style={lineStyle}>
      {segments.map((seg, j) =>
        seg.block ? (
          <span key={j} className="block-on-mobile">
            {superscriptTrademark(seg.text)}
          </span>
        ) : (
          <React.Fragment key={j}>{superscriptTrademark(seg.text)}</React.Fragment>
        )
      )}
    </p>
  ));

export default FooterLines;
